import { ReactNode } from 'react';
import styled from 'styled-components';

interface WrapperProps {
  children?: ReactNode;
}

export const Wrapper = styled.div<WrapperProps>`
  display: flex;
  align-items: center;
  flex-wrap: nowrap;
  justify-content: flex-start;
  padding-left: 0;
  background-color: ${({ theme }) => theme.palette.backgrounds.tab};

  @media (min-width: 768px) {
    display: flex;
    height: auto;
  }
`;
